export function filterEmpty (value: number | string | undefined | null, str?: string) {
  if (value === '' || value === null || value === undefined) {
    return str || '-'
  }
  return value
}

export function jsonToStr (obj: Record<string, string | number | null | undefined>) {
  const strArr:string[] = []
  if (typeof obj !== 'object') return strArr.join('&')
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    if (obj[keys[i]]) {
      strArr.push(keys[i] + '=' + obj[keys[i]])
    }
  }
  return strArr.join('&')
}

export function isNullOrEmpty (val: any) {
  return val === '' ||
    val === null ||
    val === undefined ||
    JSON.stringify(val) === '[]' ||
    JSON.stringify(val) === '{}'
}
